import { useContext } from 'react';
import logo from '../../assets/img/logo.svg';
import { AuthContext } from '../../context/authContext';
import styles from './NavBar.module.scss';

export default function NavBar() {
    const authContext = useContext(AuthContext);
    if (!authContext) throw new Error('AuthContext must be used within an AuthProvider');
    const { logout } = authContext;

    return (
        <header className={styles.menu}>
            <a href="/home">
                <h1>Movelaria</h1>
            </a>
            
            <nav className={styles.nav}>
                <a id={styles.cadastros} className={styles.links} href="/cadastros">Cadastros</a>
                <a id={styles.madeiras} className={styles.links} href="/madeiras">Madeira</a>
                <a id={styles.processos} className={styles.links} href="/processos">Processos</a>
                <a id={styles.objetos} className={styles.links} href="/produzidos">Produzidos</a>
                <a id={styles.objetos} className={styles.links} href="/pedidos">Pedidos</a>
                <a id={styles.logout} className={styles.links} onClick={() => logout()}>Logout</a>
            </nav>
        </header>
    )
}